module.exports = __webpack_public_path__ + "img/img01.bcc14ba6.jpeg";